import UserFormPage from "../users/UserFormPage";

export default UserFormPage;
